














































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';

@Component
export default class Swert extends Vue {
  @Prop(String) readonly value: string | undefined;
  msg: string | undefined = this.value;
  @Watch('value')
  onValue(val: string | undefined) {
    this.msg = val;
  }
  @Watch('msg')
  onMsg(val: string | undefined) {
    this.$emit('input', val);
  }
  mounted() {
    const swert: any = document.getElementById('component-swert');
    swert.addEventListener('webkitAnimationEnd', () => this.msg = '');
    swert.addEventListener('animationEnd', () => this.msg = '');
  }
}
